import { Base } from '@studiometa/js-toolkit';

/**
 * Panel Class.
 */
export default class Panel extends Base {
  isOpen = false;

  static config = {
    name: 'Panel',
    refs: ['close[]', 'panel', 'overlay'],
    emits: ['close-panel'],
  };

  /**
   *
   */
  mounted() {
    this.header = document.querySelector('#main-header');
  }

  /**
   * Close when press Escape key
   * @param  {object} options key
   * @param  {object} options.ESC key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closePanel();
    }
  }

  /**
   * Close on click
   * @returns {void}
   */
  onCloseClick() {
    this.closePanel();
  }

  /**
   * Close on click
   * @returns {void}
   */
  onOverlayClick() {
    this.closePanel();
  }

  /**
   * Show Popin
   * @returns {void}
   */
  openPanel() {
    this.isOpen = true;
    document.body.classList.add('overflow-hidden');
    this.header.classList.remove('z-40');
    this.header.classList.add('z-10');
    this.$el.classList.remove('hidden');

    setTimeout(() => {
      this.$el.classList.remove('pointer-events-none');
      this.$refs.overlay.classList.remove('opacity-0');
      this.$refs.panel.classList.remove('translate-x-full', 'pointer-events-none');
    }, 200);
  }

  /**
   * Close popin
   * @returns {void}
   */
  closePanel() {
    this.isOpen = false;
    this.$emit('close-panel');
    document.body.classList.remove('overflow-hidden');
    this.$refs.overlay.classList.add('opacity-0');
    this.$refs.panel.classList.remove('pointer-events-none');
    this.$refs.panel.classList.add('translate-x-full');
    this.$el.classList.add('pointer-events-none');

    setTimeout(() => {
      this.header.classList.add('z-40');
      this.header.classList.remove('z-10');
      this.$el.classList.add('hidden');
    }, 400);
  }
}
